import { store } from '../../../../store/store'
import { HeadCell } from '../../../../types'
import { hasPermission } from '../../../../utils/tools'

export const headCellsLeads: HeadCell[] = [
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'status',
  },
  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    label: 'created-at',
  },
  {
    id: 'firstName',
    numeric: false,
    disablePadding: false,
    label: 'first-name',
  },
  {
    id: 'lastName',
    numeric: false,
    disablePadding: false,
    label: 'last-name',
  },
  {
    id: 'phone',
    numeric: false,
    disablePadding: false,
    label: 'phone',
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: false,
    label: 'email',
  },
  {
    id: 'platform',
    numeric: false,
    disablePadding: false,
    label: 'platform',
  },
  {
    id: 'emailSent',
    numeric: false,
    disablePadding: false,
    label: 'email-sent',
  },
  {
    id: 'cvUploaded',
    numeric: false,
    disablePadding: false,
    label: 'CV Uploaded',
  },
]

store.subscribe(() => {
  const { permissions } = store.getState().user
  const permission = hasPermission(permissions?.leadsAndTalentsDetailsFields)
  if (permissions) {
    !permission('status') && delete headCellsLeads[0]
    !permission('createdTime') && delete headCellsLeads[1]
    !permission('firstName') && delete headCellsLeads[2]
    !permission('lastName') && delete headCellsLeads[3]
    !permission('phone') && delete headCellsLeads[4]
    !permission('email') && delete headCellsLeads[5]
    !permission('platform') && !permission('channel') && delete headCellsLeads[6]
    // Email sent column (index 7) has no permission check - always visible
  }
})
